<div class="card">
    <div class="card-body">


        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-3 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Entidade</h6>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Valor (R$)</h6>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <h6 class="mb-0">%</h6>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">&nbsp;</h6>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <h6 class="mb-0 text-nowrap">Meses</h6>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Periodicidade</h6>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-3 col-12 ps-10 pe-5">
                        <h6 class="mb-0">FINAME</h6>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{(documentoPac?.valorFinanciadoFname || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5 text-nowrap">
                        <p>{{(percetFinaciadoFname || 0) | bnMask: 'MOEDA'}}</p>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Carência</h6>
                    </div>

                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <p>{{documentoPac?.mesesCarencia}}</p>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{documentoPac?.periodicidadeCarencia}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Instituição Credenciada</h6>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{(documentoPac?.valorInstituicaoCredenciada || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5 text-nowrap">
                        <p>{{(percetInstituicaoCredenciada || 0) | bnMask: 'MOEDA'}}</p>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Amortização</h6>
                    </div>

                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <p>{{documentoPac?.mesesAmortizacao}}</p>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{documentoPac?.periodicidadeAmortizacao}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Compradora/Financiada</h6>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{(documentoPac?.valorParticipacaoFinaciado || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5 text-nowrap">
                        <p>{{(percetParticipacaoFinaciado || 0) | bnMask: 'MOEDA'}}</p>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Total</h6>
                    </div>

                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <p>{{(totalMesesPrazos || 0)}}</p>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>&nbsp;</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 col-12 ps-10 pe-5">
                        <h6 class="mb-0">Total</h6>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>{{(totalfinanciado || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <p>{{'100'}}</p>
                    </div>

                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <h6 class="mb-0">&nbsp;</h6>
                    </div>

                    <div class="col-sm-1 col-12 ps-10 pe-5">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12 ps-10 pe-5">
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>



        <div class="card" *ngIf="operacao?.idUnidadeMonetariaCobranca">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-4 col-12 ps-10">
                        <h6 class="mb-0">Custo 1</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <h6 class="mb-0">Remuneração Básica</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Fator de Alteração</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Custo Fin. Adicional</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <h6 class="mb-0">Intermed.</h6>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0" *ngIf="!isTaxaEfetiva">Remuneração do BNDES</h6>
                        <h6 class="mb-0" *ngIf="isTaxaEfetiva">Taxa Efetiva de Juros</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.nomeUnidadeMonetariaCobranca || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p *ngIf="isTaxaEfetiva">{{((operacao.taxaRemuneracaoBndes || 0) + (operacao.taxaDeRemuneracaoAgente || 0)) | bnMask: 'MOEDA'}}</p>
                        <p *ngIf="!isTaxaEfetiva">{{(operacao?.taxaRemuneracaoBndes || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaRemuneracaoBasicaBndes || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaFatorAlteracao || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaCustoFinanceiroAdicional || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao?.taxaIntermedicao || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0">Remuneração do Agente</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao.nomeUnidadeMonetariaCobranca || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao.taxaDeRemuneracaoAgente || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-12 ps-10">
                        <h6 class="mb-0">Custo Financeiro</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.idUnidadeMonetariaCobranca}} {{operacao?.idUnidadeMonetariaCobranca && operacao?.nomeUnidadeMonetariaCobranca ? '-' : ''}} {{operacao?.nomeUnidadeMonetariaCobranca}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Modalidade de Juros</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <p>{{modalidadeDeJuros}}</p>
                    </div>
                    <div class="col-sm-1 col-12 p-0">
                        <p>{{''}}</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="card" *ngIf="operacao?.idUnidadeMonetariaCobranca2">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-4 col-12 ps-10">
                        <h6 class="mb-0">Custo 2</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <h6 class="mb-0">Remuneração Básica</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Fator de Alteração</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Custo Fin. Adicional</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <h6 class="mb-0">Intermed.</h6>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0" *ngIf="!isTaxaEfetiva2">Remuneração do BNDES</h6>
                        <h6 class="mb-0" *ngIf="isTaxaEfetiva2">Taxa Efetiva de Juros</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.nomeUnidadeMonetariaCobranca2 || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p *ngIf="isTaxaEfetiva2">{{((operacao.taxaRemuneracaoBndes2 || 0) + (operacao.taxaDeRemuneracaoAgente2 || 0)) | bnMask: 'MOEDA'}}</p>
                        <p *ngIf="!isTaxaEfetiva2">{{(operacao?.taxaRemuneracaoBndes2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaRemuneracaoBasicaBndes2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaFatorAlteracao2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaCustoFinanceiroAdicional2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao?.taxaIntermedicao2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0">Remuneração do Agente</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao.nomeUnidadeMonetariaCobranca2 || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao.taxaDeRemuneracaoAgente2 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-12 ps-10">
                        <h6 class="mb-0">Custo Financeiro</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.idUnidadeMonetariaCobranca2}} {{operacao?.idUnidadeMonetariaCobranca2 && operacao?.nomeUnidadeMonetariaCobranca2 ? '-' : ''}} {{operacao?.nomeUnidadeMonetariaCobranca2}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Modalidade de Juros</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <p>{{modalidadeDeJuros}}</p>
                    </div>
                    <div class="col-sm-1 col-12 p-0">
                        <p>{{''}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="operacao?.idUnidadeMonetariaCobranca3">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-4 col-12 ps-10">
                        <h6 class="mb-0">Custo 3</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <h6 class="mb-0">Remuneração Básica</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Fator de Alteração</h6>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Custo Fin. Adicional</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <h6 class="mb-0">Intermed.</h6>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0" *ngIf="!isTaxaEfetiva3">Remuneração do BNDES</h6>
                        <h6 class="mb-0" *ngIf="isTaxaEfetiva3">Taxa Efetiva de Juros</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.nomeUnidadeMonetariaCobranca3 || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p *ngIf="isTaxaEfetiva3">{{((operacao.taxaRemuneracaoBndes3 || 0) + (operacao.taxaDeRemuneracaoAgente3 || 0)) | bnMask: 'MOEDA'}}</p>
                        <p *ngIf="!isTaxaEfetiva3">{{(operacao?.taxaRemuneracaoBndes3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaRemuneracaoBasicaBndes3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaFatorAlteracao3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{(operacao?.taxaCustoFinanceiroAdicional3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao?.taxaIntermedicao3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2  col-12 ps-10">
                        <h6 class="mb-0">Remuneração do Agente</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao.nomeUnidadeMonetariaCobranca3 || '-'}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{(operacao.taxaDeRemuneracaoAgente3 || 0) | bnMask: 'MOEDA'}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>&nbsp;</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-12 ps-10">
                        <h6 class="mb-0">Custo Financeiro</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{operacao?.idUnidadeMonetariaCobranca3}} {{operacao?.idUnidadeMonetariaCobranca3 && operacao?.nomeUnidadeMonetariaCobranca3 ? '-' : ''}} {{operacao?.nomeUnidadeMonetariaCobranca3}}</p>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <p>{{''}}</p>
                    </div>
                    <div class="col-sm-2 col-12  p-0">
                        <h6 class="mb-0">Modalidade de Juros</h6>
                    </div>
                    <div class="col-sm-2 col-12 p-0">
                        <p>{{modalidadeDeJuros}}</p>
                    </div>
                    <div class="col-sm-1 col-12 p-0">
                        <p>{{''}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div  class="card-body">
                <div class="row">
                    <div class="col-sm-3 col-12 ps-10">
                        <h6 class="mb-0">Data de Contratação</h6>
                    </div>
                    <div class="col-sm-5 col-12  p-0">
                        <p>{{(documentoPac.dataContratacao | date: 'dd/MM/yyyy') || '-'}}</p>
                    </div>
                </div>

                <div class="row" *ngIf="false">
                    <div class="col-sm-3 col-12 ps-10">
                        <h6 class="mb-0">Data da Ultima Carência</h6>
                    </div>
                    <div class="col-sm-5 col-12  p-0">
                        <p>{{(documentoPac.dataUltimaCarencia | date: 'dd/MM/yyyy') || '-'}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 col-12 ps-10">
                        <h6 class="mb-0">Garantias</h6>
                    </div>
                    <div class="col-sm-5 col-12  p-0">
                        <p>{{documentoPac.garantias}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-4 col-12 ps-10">
                        <h6 class="mb-0">Operações Garantidas pelo FGI</h6>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-2 col-12 ps-10">
                        <h6 class="mb-0">Risco Assumido</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{documentoPac.taxaGarantiaFgi || '-'}}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-12 ps-10">
                        <h6 class="mb-0">Classificação de Risco</h6>
                    </div>
                    <div class="col-sm-1 col-12  p-0">
                        <p>{{documentoPac.classificacaoRisco || '-'}}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
